@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.ConfirmActionDialog {
  @extend %font-family-primary;

  display: flex;
  flex-direction: column;
  row-gap: 24px;
  min-width: 402px;
  max-width: 402px;
  color: $theme-color-text;
  background-color: $theme-color-background;
  padding: 24px;
  border: 1px solid $theme-color-borders;
  border-radius: 8px;
  word-break: break-word;
  box-shadow: 0 4px 16px 0 $color-dropdown-box-shadow;

  .TextDialog {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }

  .buttonWrapper {
    text-align: right;
  }

  .secondaryButtonWrapper {
    display: flex;

    .rightButtons {
      margin-left: auto;
    }
  }
}
